<template>
  <CheckRoleDialog
    :dialogTitle="dialogTitle"
    :centerDialogVisible="visible"
    @updateVisible="updateVisible"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
    :popupWidth="'600px'"
    :appendToBody="false"
  >
    <el-form label-width="130px">
      <el-form-item v-if="isUnifyIdentity" label="统一身份认证账号:" prop="uid">
        <span>{{ userData.uid }}</span>
      </el-form-item>
      <el-form-item label="用户名称:" prop="realName">
        <span>{{ userData.realName }}</span>
      </el-form-item>
      <el-form-item label="部门:" prop="companyName">
        <span>{{ departmentName }}</span>
      </el-form-item>
      <el-form-item label="已有角色:" prop="roleAuth">
        <div v-for="(item, index) in roleList" :key="index">
          {{ item.roleName }}
        </div>
      </el-form-item>
      <el-form-item label="已有权限:">
        <div style="overflow-y: auto;max-height: 200px">
          <el-tree
            :data="authTree"
            :props="defaultProps"
            :default-expand-all="true"
          ></el-tree>
        </div>
      </el-form-item>
    </el-form>
  </CheckRoleDialog>
</template>

<script>
import CheckRoleDialog from "../../../../components/common/epecDialog";
import Api from "../../api/authority/index";
export default {
  name: "checkUserDialog",
  components: {
    CheckRoleDialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialogTitle: "查看员工",
      roleList: [],
      authTree: [],
      defaultProps: {
        children: "childList",
        label: "authName",
      },
      departmentName: "",
      isUnifyIdentity: this.$store.state.USERINFO.unifyIdentity, ///1是统一身份，0不是统一身份
    };
  },
  computed: {},
  created() {
    this.getRoleList();
    this.getAuthTree();
    this.getDepartmentInfo();
  },
  methods: {
    updateVisible() {},
    resetPopupData() {
      this.$emit("close");
    },
    submitPopupData() {
      this.$emit("close");
    },
    getRoleList() {
      let params = {
        memberId: this.userData.memberId,
      };
      Api.checkHasRole(params).then((res) => {
        this.roleList = res.data;
      });
    },
    getAuthTree() {
      let params = {
        memberId: this.userData.memberId,
      };
      Api.checkHasAuth(params).then((res) => {
        this.authTree.push(res.data);
      });
    },
    getDepartmentInfo() {
      let params = {
        memberId: this.userData.memberId,
      };
      Api.queryDepartmentInfo(params).then((res) => {
        if (res.code == "200") {
          this.departmentName = res.data.orgName;
        }
      });
    },
  },
};
</script>

<style scoped></style>
